import React, { Component, Fragment } from 'react';
import { getText } from '../../helpers';

export default class ConsequenceCell extends Component {
  constructor(props){
    super(props);
    this.state = {
      expanded: false,
      cellClass: "consequences-cell-content",
    }
  }

  showMore = (evt) => {
    evt.stopPropagation();
    this.setState({ expanded: true, cellClass: "consequences-cell-content expanded" });
  }

  showLess = (evt) => {
    evt.stopPropagation();
    this.setState({ expanded: false, cellClass: "consequences-cell-content" });
  }

  render() {
    const { children, column, expandable } = this.props;
    const { expanded, cellClass } = this.state;
    const { showLess, showMore } = this;
    return (
      <Fragment>
        <div column={column} className={cellClass} title={children}>{ children }</div>
        {
          expandable &&
          <div>
            {
              expanded
              ?
              <span onClick={showLess} className="anchor-button font-95-percent">{getText('Show less')}</span>
              :
              <span onClick={showMore} className="anchor-button font-95-percent">{getText('Show more')}</span>
            }
          </div>
        }
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/consequences_tables/consequence_cell.js